import type { QueryKey } from 'react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IAny = any;

export type IMaybeAsync<TReturnType> = TReturnType | Promise<TReturnType>;

export type IMakeOptional<TType, TKey extends keyof TType> = Omit<TType, TKey> &
  Partial<Pick<TType, TKey>>;

export type IMakeRequired<TType, TKey extends keyof TType> = Omit<TType, TKey> &
  Required<Pick<TType, TKey>>;

export type ISize = {
  width: number;
  height: number;
};

export type IRange = {
  min: number;
  max: number;
};

export enum ITimeUnit {
  MILLISECOND = 1,
  SECOND = 1 * 1000,
  MINUTE = 60 * 1 * 1000,
  HOUR = 60 * 60 * 1 * 1000,
  DAY = 24 * 60 * 60 * 1 * 1000,
  WEEK = 7 * 24 * 60 * 60 * 1 * 1000,
  MONTH = 30 * 24 * 60 * 60 * 1 * 1000,
}

export enum IFileSizeUnit {
  BYTE = 1,
  KILOBYTE = 1 * 1000,
  MEGABYTE = 1 * 1000 * 1000,
}

export enum IDistanceUnit {
  KILOMETER = 1 * 1000,
}

export type IFormMode = 'creation' | 'edition';

export type IQueryKeyFactory<TValues extends object = never> = (
  values?: TValues,
) => QueryKey | undefined;

export type IGeolocation = {
  longitude: number;
  latitude: number;
};
